import React, { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { ShoppingCartIcon, PhoneIcon, EnvelopeIcon, Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { useCartStore } from '../stores/cartStore'

const Header: React.FC = () => {
  const { items, toggleCart } = useCartStore()
  const itemCount = items.length
  const navigate = useNavigate()
  const location = useLocation()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const scrollToTop = () => {
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50)
  }

  const handleNavigate = (path: string) => {
    setMobileMenuOpen(false)
    if (path === '/repair' && location.pathname === '/repair') {
      navigate('/repair?reset=' + Date.now())
    } else {
      navigate(path)
    }
    scrollToTop()
  }

  const navItems = [
    { label: 'MacBook Reparatur', path: '/macbook-reparatur', highlight: true },
    { label: 'Handy Reparatur', path: '/repair' },
    { label: 'Sendung verfolgen', path: '/track' },
    { label: 'Blog', path: '/blog' },
    { label: 'Kontakt', path: '/kontakt' },
  ]

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gray-900 text-gray-300 py-2 text-sm">
        <div className="max-w-7xl mx-auto px-4 flex justify-center items-center gap-6">
          <a
            href="https://wa.me/491605010907"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 hover:text-white transition-colors"
          >
            <PhoneIcon className="w-3.5 h-3.5" />
            0160-5010907
          </a>
          <span className="text-gray-600">|</span>
          <a
            href="mailto:service@phone-medic.de"
            className="flex items-center gap-1.5 hover:text-white transition-colors"
          >
            <EnvelopeIcon className="w-3.5 h-3.5" />
            service@phone-medic.de
          </a>
          <span className="text-gray-600 hidden sm:inline">|</span>
          <span className="text-gray-400 hidden sm:inline">Bundesweiter Versand · Express 24h verfügbar</span>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link
              to="/"
              onClick={scrollToTop}
              className="flex items-center gap-2 shrink-0"
            >
              <img src="/logo.png" alt="PhoneMedic" className="h-10 w-auto" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-1">
              {navItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => handleNavigate(item.path)}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    item.highlight
                      ? 'text-indigo-700 bg-indigo-50 hover:bg-indigo-100'
                      : location.pathname === item.path
                      ? 'text-gray-900 bg-gray-100'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav>

            {/* Right side */}
            <div className="flex items-center gap-2">
              {/* Cart */}
              <button
                onClick={toggleCart}
                className="relative p-2 text-gray-500 hover:text-gray-900 transition-colors rounded-md hover:bg-gray-50"
              >
                <ShoppingCartIcon className="w-5 h-5" />
                {itemCount > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 bg-indigo-600 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center font-medium">
                    {itemCount}
                  </span>
                )}
              </button>

              {/* Mobile menu toggle */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden p-2 text-gray-500 hover:text-gray-900 rounded-md hover:bg-gray-50"
              >
                {mobileMenuOpen ? (
                  <XMarkIcon className="w-5 h-5" />
                ) : (
                  <Bars3Icon className="w-5 h-5" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-100 bg-white">
            <nav className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-1">
              {navItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => handleNavigate(item.path)}
                  className={`text-left px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    item.highlight
                      ? 'text-indigo-700 bg-indigo-50'
                      : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
        )}
      </header>
    </>
  )
}

export default Header
